import { createResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_CUSTOM_FIELDS_DIRECTORY } from '../constants.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const customFieldsDirectoryResource = createResource<any>({
	type: RESOURCE_TYPE_CUSTOM_FIELDS_DIRECTORY,
	getKey: () => 'state',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-custom-fields-directory", jiraSpaEntry: "async-resource-custom-fields-directory" */ './get-data'
		),
});
